import { useEffect, useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import CustomDialog from '../../partials/CustomDialog';
import VirtualTable from "../../partials/VirtualTable";

import store from '../../../store';
import apiClient from "../../../services/api";
import { toggleMessageOpen } from "../../../store/actions/Message";
import { createConfirmAction } from "../../../store/actions/ConfirmDialog";
import { setIsSceneUpdated, setStoreData, setStoreUpdated, setStoresData } from "../../../store/actions/Store";

const columns = [
    { id: 'number', title: 'Version', numeric: true },
    { id: 'created_at', title: 'Creation', numeric: false, isDate: true },
    { id: 'updated_at', title: 'Modify', numeric: false, isDate: true },
    { id: 'revert', title: 'Revert', isRevert: true },
];

export const VersionsDialog = ({open, handleClose, item}) => {
    const { t } = useTranslation();
    const [fetching, setFetching] = useState(false);
    const [floorPlanVersions, setFloorPlanVersions] = useState([]);

    useEffect(() => {
        if(!item) {
            return;
        }

        loadFloorPlanVersions();
    }, [item]);

    const loadFloorPlanVersions = () => {
        setFloorPlanVersions([]);
        setFetching(true);

        apiClient.post('/api/easy-floor/load-versions', {id: item.floor_plan_id ? item.floor_plan_id : item.id}).then(response => {
            if(response.data.success) {
                setFloorPlanVersions(response.data.floor_plan_versions);
                setFetching(false);
            }
        })
    }

    useEffect(() => {
        console.log(floorPlanVersions);
    }, [floorPlanVersions])

    const onRevert = (id) => {
        store.dispatch(createConfirmAction(handleRevert, t('Are you sure?'), id));
    }

    const handleRevert = (id) => {
        const postData = { id: item.floor_plan_id ? item.floor_plan_id : item.id, floorPlanVersionID: id };

        apiClient.post('/api/easy-floor/revert', postData).then(response => {
            if(response.data.success) {
                //store.dispatch(setStoresData(response.data.floor_plans));

                console.log(response);
                
                handleClose();
                
                response.data.floor_plan.width = response.data.floor_plan.width * response.data.floor_plan.scale;
                response.data.floor_plan.depth = response.data.floor_plan.depth * response.data.floor_plan.scale;
                response.data.texture.width = response.data.texture.width * response.data.floor_plan.scale / 10;
                response.data.texture.depth = response.data.texture.height * response.data.floor_plan.scale / 10;

                store.dispatch(setStoreData(response.data));
                store.dispatch(setIsSceneUpdated(true));
                store.dispatch(setStoreUpdated(true));

            } else {
                store.dispatch(toggleMessageOpen('An error occurred while revert!', 'error'));
            }
        })
    }

    return (
        <CustomDialog
            fullWidth
            maxWidth="lg"
            scroll="paper"
            open={open}
            onClose={handleClose}
            title={<Trans>Versions</Trans>}
        >
            {!fetching && floorPlanVersions && (
                <VirtualTable
                    rows={floorPlanVersions}
                    columns={columns}
                    gridTemplateColumns={'1fr 3fr 3fr 1fr'}
                    item={item}
                    action={onRevert}
                    filter
                />
            )}
            {fetching && (
                <Typography><Trans>Loading versions...</Trans></Typography>
            )}
        </CustomDialog>
    )
}